import React, { Suspense, lazy } from "react";

// The enquiry / site-visit dialog (and the dialog library) is downloaded the first time someone opens it,
// so it isn't part of the code every visitor waits for.
const LeadDialog = lazy(() => import("@/components/LeadDialog"));

export default function LazyLeadDialog(props) {
    return <Suspense fallback={null}><LeadDialog {...props} /></Suspense>;
}
